import React from 'react'

function UserPage() {
  return <div>UserPage</div>
}

export default UserPage
